import { Button, Flex, Group, NumberInput, Stack, Text, Textarea, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { ElementType, FC } from "react";

interface Props {
  WrapperForFields: ElementType;
  wrapperProps: Record<string, unknown>;
  form: any;
  activeStep: number;
  onCancel?: () => void;
  loading: boolean;
  onSubmit: () => void;
}

const EditStep3: FC<Props> = ({
  WrapperForFields,
  wrapperProps,
  form,
  activeStep,
  onCancel,
  loading,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Stack gap="md">
      <Title order={4}>{t("components.CreateCarForm.titles.extraOptionalDetails")}</Title>

      <WrapperForFields {...wrapperProps}>
        <NumberInput
          label={t("car.number_of_previous_owner")}
          placeholder={t("components.CreateCarForm.placeholders.number_of_previous_owner")}
          min={0}
          {...form.getInputProps("number_of_previous_owner")}
          onChange={(value) =>
            form.setFieldValue("number_of_previous_owner", value === "" ? 0 : Number(value))
          }
        />
      </WrapperForFields>

      <Textarea
        label={t("car.special_equipment")}
        placeholder={t("components.CreateCarForm.placeholders.special_equipment")}
        minRows={4}
        {...form.getInputProps("special_equipment")}
      />

      <Group justify="space-between" mt="2em">
        <Text fw={500} fz="sm">
          {t("common.steps", { currentStep: activeStep + 1, totalSteps: 4 })}
        </Text>

        <Flex justify="end" gap="md">
          {onCancel && (
            <Button variant="outline" onClick={onCancel} disabled={loading}>
              {t("common.cancel")}
            </Button>
          )}

          <Button type="button" onClick={onSubmit} loading={loading}>
            {t("components.CreateCarForm.editSubmitButton")}
          </Button>
        </Flex>
      </Group>
    </Stack>
  );
};

export default EditStep3;
